import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { AUTOMATIC_COUPON_SETTINGS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getAutomaticCouponSettingTranslationAction = createAsyncThunk(
    'coupon/getAutomaticCouponSettingTranslationAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ AUTOMATIC_COUPON_SETTINGS_PATH }/${ data.automaticCouponType }/translation?languageCode=${ data.languageCode || 'PL' }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getAutomaticCouponSettingTranslationSlice = createSlice({
    name: 'getAutomaticCouponSettingTranslationSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getAutomaticCouponSettingTranslationAction.pending, () => STATE__API__STARTED);
        builder.addCase(getAutomaticCouponSettingTranslationAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getAutomaticCouponSettingTranslationAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getAutomaticCouponSettingTranslationState = (state) => state.coupon.getAutomaticCouponSettingTranslation;
export default getAutomaticCouponSettingTranslationSlice.reducer;
